module.exports = __webpack_public_path__ + "img/people-fill.435d04d6.svg";